import { Tooltip2, Tooltip2Props } from "@blueprintjs/popover2"
import React from "react"
import classNames from "utils/classNames"
import "./styles.scss"
export type CustomTooltipProps = Tooltip2Props & {
  /**
   * Denotes the theme of the tooltip,
   * if set to true then the tooltip whill have a white background with dark colours and opposite
   * if set to false
   */
  light?: boolean
  /**
   * Denotes the size of the tooltip
   */
  small?: boolean
  minimal?: boolean
  /**
   * className for the actual ToolTip component
   */
  className?: string
  /**
   * className for the Popover component which houses all the context
   */
  popoverClassName?: string
  /**
   * className for the portal component which provides a backdrop for the tooltip
   */
  portalClassName?: string
  /**
   * The main content that goes inside the tooltip
   * it could be a react element or standard html
   */
  content: React.FC | any
}
const CustomTooltip = ({
  children,
  light,
  small = true,
  minimal,
  className,
  popoverClassName,
  portalClassName,
  content,
  ...OtherProps
}: CustomTooltipProps) => {
  return (
    <Tooltip2
      content={content}
      className={classNames("vt-tooltip-content", className)}
      popoverClassName={classNames(
        "vt-tooltip-base",
        light && "vt-tooltip-light",
        small && "vt-tooltip-small",
        minimal && "vt-tooltip-minimal",
        popoverClassName
      )}
      portalClassName={portalClassName}
      {...OtherProps}
    >
      {children}
    </Tooltip2>
  )
}

export default CustomTooltip
